'use client';

import Link from 'next/link';
import type { FC, MouseEvent, PropsWithChildren } from 'react';
import { useStore } from '@/store/store';
import { getGameCollectionSelectedProps } from '@/tracking/amplitude/events/general/game-collection-selected';

type CollectionsEntryShowcaseTileProps = PropsWithChildren<{
    href: string;
    ariaLabel: string;
    categoryUid: string;
    zoneTitle: string;
}>;

export const CollectionsEntryShowcaseTile: FC<CollectionsEntryShowcaseTileProps> = ({
    href,
    ariaLabel,
    categoryUid,
    zoneTitle,
    children
}) => {
    const handleShowLoading = useStore((s) => s.loading.handleShowLoading);
    const sendEvent = useStore((s) => s.tracking.sendEvent);

    const handleClick = (_event: MouseEvent<HTMLAnchorElement>) => {
        sendEvent([{ destination: 'amplitude', eventProps: getGameCollectionSelectedProps(categoryUid, zoneTitle) }]);
        handleShowLoading();
    };

    return (
        <Link
            href={href}
            className="collections-entry-showcase__tile"
            aria-label={ariaLabel}
            prefetch={false}
            onClick={handleClick}>
            {children}
        </Link>
    );
};
